<template>
  <div class="list-actions">
    <template v-for="action in availableActions">
      <check-permission
        v-if="forceNotExact || !action.id"
        :key="`action_${action.id || action.event}`"
        :permissions="actionPermissions(action)"
      >
        <list-action :action="action" :object="{}" v-on="$listeners" />
      </check-permission>

      <check-permission-for-exact-entity
        v-else
        :key="`action_exact_${action.id || action.event}`"
        :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
        :permission-entity-id="action.id"
        :permission-entity-type="'button'"
        :role-entity-id="entityIds"
        :role-entity-type="entityType"
      >
        <list-action :action="action" :object="{}" v-on="$listeners" />
      </check-permission-for-exact-entity>
    </template>

    <slot name="extraActions" />
  </div>
</template>

<script>
import { actionsMixin } from '@/mixins/actions';
import { flat } from '@/utils/flat';

import ListAction from './ListAction.vue';

// @vuese
// Akcje listy dokumentów
// @group Components
export default {
  name: 'Actions',
  components: { ListAction },
  mixins: [actionsMixin],
  props: {
    // Identyfikatory wybranych encji
    entityIds: { type: Array, required: false },
    // Typ encji
    entityType: { type: String, required: false },
    // Czy wymuszać sprawdzanie uprawnień "po staremu" - bez dokładnej encji
    forceNotExact: { type: Boolean, default: false }
  },
  computed: {
    availableActions() {
      if (this.entityIds.length === 1) {
        return this.actions;
      }
      return this.actions.filter(action => !action.singleOnly);
    }
  },
  methods: {
    // @vuese
    // Uprawnienia do akcji
    actionPermissions(action) {
      let permissions = action.permissions ? action.permissions : this.getPermissions(action.permissionTypes);
      if (!this.entityIds?.length || !this.entityType || action.forceNoEntity) {
        return permissions;
      }

      if (!Array.isArray(permissions)) {
        permissions = [permissions];
      }

      permissions = flat(
        permissions.map(permission => this.entityIds.map(entityId => `${permission}:${this.entityType}:${entityId}`))
      );

      if (action.id) {
        permissions.push('BUTTON.USE:button:' + action.id);
      }

      return permissions;
    }
  }
};
</script>

<style>
.list-actions {
  position: sticky;
  top: 0;
  background: white;
  padding-top: 0.5rem;
}
</style>
